/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Location,
  LocationContents,
  LocationJumpPointsList,
  LocationPeople,
  LocationPeopleParams,
  LocationShops,
  LocationTreeNode,
  Locations,
  LocationsParams,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Locations list
 */
export const locations = (
    params?: MaybeRefOrGetter<LocationsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Locations>(
      {url: `/locations`, method: 'GET',
        params, signal
    },
      );
    }




export const getLocationsQueryKey = (params?: MaybeRefOrGetter<LocationsParams>,) => {
    return [
    'locations', ...(params ? [params] : [])
    ] as const;
    }


export const getLocationsQueryOptions = <TData = Awaited<ReturnType<typeof locations>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<LocationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getLocationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locations>>> = ({ signal }) => locations(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locations>>, TError, TData>
}

export type LocationsQueryResult = NonNullable<Awaited<ReturnType<typeof locations>>>
export type LocationsQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Locations list
 */

export function useLocations<TData = Awaited<ReturnType<typeof locations>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<LocationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locations>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Location jump points
 */
export const locationJumpPoints = (

 signal?: AbortSignal
) => {


      return axiosClient<LocationJumpPointsList>(
      {url: `/locations/jump-points`, method: 'GET', signal
    },
      );
    }




export const getLocationJumpPointsQueryKey = () => {
    return [
    'locations','jump-points'
    ] as const;
    }


export const getLocationJumpPointsQueryOptions = <TData = Awaited<ReturnType<typeof locationJumpPoints>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationJumpPoints>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getLocationJumpPointsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationJumpPoints>>> = ({ signal }) => locationJumpPoints(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locationJumpPoints>>, TError, TData>
}

export type LocationJumpPointsQueryResult = NonNullable<Awaited<ReturnType<typeof locationJumpPoints>>>
export type LocationJumpPointsQueryError = ErrorType<unknown>


/**
 * @summary Location jump points
 */

export function useLocationJumpPoints<TData = Awaited<ReturnType<typeof locationJumpPoints>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationJumpPoints>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationJumpPointsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Location detail
 */
export const location = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<Location>(
      {url: `/locations/${slug}`, method: 'GET', signal
    },
      );
    }




export const getLocationQueryKey = (slug: MaybeRefOrGetter<string>,) => {
    return [
    'locations',slug
    ] as const;
    }


export const getLocationQueryOptions = <TData = Awaited<ReturnType<typeof location>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof location>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getLocationQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof location>>> = ({ signal }) => location(slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof location>>, TError, TData>
}

export type LocationQueryResult = NonNullable<Awaited<ReturnType<typeof location>>>
export type LocationQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Location detail
 */

export function useLocation<TData = Awaited<ReturnType<typeof location>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof location>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Location contents
 */
export const locationContents = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<LocationContents>(
      {url: `/locations/${slug}/contents`, method: 'GET', signal
    },
      );
    }




export const getLocationContentsQueryKey = (slug: MaybeRefOrGetter<string>,) => {
    return [
    'locations',slug,'contents'
    ] as const;
    }


export const getLocationContentsQueryOptions = <TData = Awaited<ReturnType<typeof locationContents>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationContents>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getLocationContentsQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationContents>>> = ({ signal }) => locationContents(slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locationContents>>, TError, TData>
}

export type LocationContentsQueryResult = NonNullable<Awaited<ReturnType<typeof locationContents>>>
export type LocationContentsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Location contents
 */

export function useLocationContents<TData = Awaited<ReturnType<typeof locationContents>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationContents>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationContentsQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * The reader's friends and fleet mates at the place or inside it. A token lists fleet mates only with the fleet or fleet:read scope
 * @summary Location people
 */
export const locationPeople = (
    slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<LocationPeopleParams>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);
params = toValue(params);

      return axiosClient<LocationPeople>(
      {url: `/locations/${slug}/people`, method: 'GET',
        params, signal
    },
      );
    }




export const getLocationPeopleQueryKey = (slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<LocationPeopleParams>,) => {
    return [
    'locations',slug,'people', ...(params ? [params] : [])
    ] as const;
    }


export const getLocationPeopleQueryOptions = <TData = Awaited<ReturnType<typeof locationPeople>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<LocationPeopleParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationPeople>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getLocationPeopleQueryKey(slug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationPeople>>> = ({ signal }) => locationPeople(slug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locationPeople>>, TError, TData>
}

export type LocationPeopleQueryResult = NonNullable<Awaited<ReturnType<typeof locationPeople>>>
export type LocationPeopleQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Location people
 */

export function useLocationPeople<TData = Awaited<ReturnType<typeof locationPeople>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<LocationPeopleParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationPeople>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationPeopleQueryOptions(slug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Location shops
 */
export const locationShops = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<LocationShops>(
      {url: `/locations/${slug}/shops`, method: 'GET', signal
    },
      );
    }




export const getLocationShopsQueryKey = (slug: MaybeRefOrGetter<string>,) => {
    return [
    'locations',slug,'shops'
    ] as const;
    }


export const getLocationShopsQueryOptions = <TData = Awaited<ReturnType<typeof locationShops>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationShops>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getLocationShopsQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationShops>>> = ({ signal }) => locationShops(slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locationShops>>, TError, TData>
}

export type LocationShopsQueryResult = NonNullable<Awaited<ReturnType<typeof locationShops>>>
export type LocationShopsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Location shops
 */

export function useLocationShops<TData = Awaited<ReturnType<typeof locationShops>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationShops>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationShopsQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Location system tree
 */
export const locationTree = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<LocationTreeNode>(
      {url: `/locations/${slug}/tree`, method: 'GET', signal
    },
      );
    }




export const getLocationTreeQueryKey = (slug: MaybeRefOrGetter<string>,) => {
    return [
    'locations',slug,'tree'
    ] as const;
    }


export const getLocationTreeQueryOptions = <TData = Awaited<ReturnType<typeof locationTree>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationTree>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getLocationTreeQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationTree>>> = ({ signal }) => locationTree(slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locationTree>>, TError, TData>
}

export type LocationTreeQueryResult = NonNullable<Awaited<ReturnType<typeof locationTree>>>
export type LocationTreeQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Location system tree
 */

export function useLocationTree<TData = Awaited<ReturnType<typeof locationTree>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationTree>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationTreeQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






